<template>
  <div>
    <v-row justify="space-between">
      <v-col>
        <v-card-title v-if="title">{{ title }}</v-card-title>
        <v-card-subtitle v-if="subtitle">{{ subtitle }}</v-card-subtitle>
      </v-col>
      <v-col class="flex-grow-0">
        <AddTypeButton @addType="addType" />
      </v-col>
    </v-row>

    <v-card-text>
      <div>
        <div
          v-for="(exception, index) in exceptions"
          :key="exception.uuid || exception.exceptionalEventUuid"
          class="mb-3"
        >
          <DatePickerExceptional
            :value="exceptions[index]"
            @input="editClosure($event, index)"
            @change="$emit('change')"
            @clickCanceled="$emit('clickCanceled', { exceptionalEventUuid: exception.exceptionalEventUuid })"
            @remove="$emit('removeExceptionalEvent', index)"
          />
        </div>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import uuid from 'uuid'

import DatePickerExceptional from '@/components/settings/DatePickerExceptional'
import AddTypeButton from '@/components/settings/AddTypeButton'

export default {
  name: 'ExceptionalClosure',

  components: { AddTypeButton, DatePickerExceptional },

  props: {
    exceptions: {
      type: Array,
      required: true
    },
    subtitle: String,
    title: String
  },

  methods: {
    addType({ mode, type }) {
      switch (mode) {
        case 'addDate':
          this.exceptions.unshift({ eventType: type, type: 'date', toCancelAppointments: [], uuid: uuid() })
          break
        case 'addDateRange':
          this.exceptions.unshift({ eventType: type, type: 'range', toCancelAppointments: [], uuid: uuid() })
          break
        default:
          throw new Error('this case is not supported')
      }
    },
    editClosure(event, index) {
      const exceptions = this.exceptions.map((el, i) => (i === index ? event : el))
      this.$emit('input', exceptions)
    }
  }
}
</script>
